<template>
    <div v-if="show">
        <div id="cert" class="amTealregular">
            <div class="certext">CERTIFICATE OF AUTHENTICITY</div>
            <div class="titlebar">{{artTitle}}</div>
            <div class="artistname">{{fullname}}</div>
            <div class="signaturepanel">artist signature</div>
        </div>
        <div id="cert">
            <div class="rightCol">
                <div class="imgBox" :style="{ 'background-image': `url(${img})`}"></div>
                <div class="titleback">{{artTitle}}</div>
                <div class="dimensions">{{dime}}</div>
                <div class="usertag">@{{username}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import db from '../main'
export default {
    name: 'cfront',
    data(){
        return {
            docid: "",
            img: "",
            fullname: "",
            artTitle: "",
            width: "",
            height: "",
            unit: "",
            depth: "",
            username: "",
            output: null,
            dime: "",
            show: false,
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                const userID = firebase.auth().currentUser.uid;
                const checkAdmin = firebase.functions().httpsCallable('adminCheck')
                checkAdmin({uid:userID}).then(result => {
                    console.log('result of check is...', result.data)
                    if(result.data !== 'error') {
                        this.show = true
        this.docid = this.$route.query.docid
        this.img = this.$route.query.img
        this.fullname = this.$route.query.fullname.toUpperCase()
        if (this.docid){
            db.collection('posts').doc(this.docid).get().then(doc => {
                if (doc){
                    const artpost = doc.data()
                    const artTitle = artpost.artTitle
                    const artYear = artpost.artYear
                    const width = artpost.width
                    const height = artpost.length
                    const depth = artpost.depth
                    const unit = artpost.unit
                    this.username = artpost.username
                    this.artTitle = artTitle + ", "+ artYear
                    var dimens = ""
                    if (depth > 0){
                        dimens = String(height) + "h  x " + width + "w x "+ depth + "d "+ unit  
                    } else {
                        dimens = String(height) + "h  x " + width + "w " + unit 
                    }
                    this.dime = dimens
                }
            })
        }

                    } else {
                        firebase.auth().signOut().then(() => this.$router.push('/'))
                    }
                })
        //         const userin = firebase.auth().currentUser.uid
        //         db.collection('amkey').doc('kNd00RNaepaxE4M08lUW').get().then(keydoc => {
        //             if (keydoc){
        //                 const data = keydoc.data()
        //                 const admin = data.A1
        //                 if (userin !== admin){
        //                     this.$router.push({name:"index"})
        //                 } else {
        // this.show = true
        // this.docid = this.$route.query.docid
        // this.img = this.$route.query.img
        // this.fullname = this.$route.query.fullname.toUpperCase()
        // if (this.docid){
        //     db.collection('posts').doc(this.docid).get().then(doc => {
        //         if (doc){
        //             const artpost = doc.data()
        //             const artTitle = artpost.artTitle
        //             const artYear = artpost.artYear
        //             const width = artpost.width
        //             const height = artpost.length
        //             const depth = artpost.depth
        //             const unit = artpost.unit
        //             this.username = artpost.username
        //             this.artTitle = artTitle + ", "+ artYear
        //             var dimens = ""
        //             if (depth > 0){
        //                 dimens = String(height) + "h  x " + width + "w x " + unit  
        //             } else {
        //                 dimens = String(height) + "h  x " + width + "w " + unit 
        //             }
        //             this.dime = dimens
        //         }
        //     })
        // }
        //                 }
        //             }
        //         })
            } else {
                this.$router.push({name:"index"})
            }
        })

    }
}
</script>
<style scoped>
#cert {
    width: 532px;
    height: auto;
}

.certext {
    width: 100%;
    height: auto;
    margin-top: 150px;
    text-align: center;
    color: #00a89d;
    font-family: 'cocomatpro-bold';
    font-size: 1.2em;
    float: left;
    clear: right;
}

.artistname {
    width: 100%;
    height: auto;
    text-align: center;
    color: black;
    font-family: 'cocomatpro-regular';
    font-size: 1em;
    float: left;
    clear: right;
    margin-top: -5px;
}

.titlebar {
    width: 100%;
    height: auto;
    margin-top: -3px;
    text-align: center;
    color: gray;
    font-family: 'cocomatpro-regular';
    font-size: 1.2em;
    float: left;
    clear: right;
}

.signaturepanel {
    width: 100%;
    height: auto;
    margin-top: 75px;
    text-align: center;
    color: #A9D9C2;
    font-family: 'cocomatpro-regular';
    font-size: .5em;
    float: left;
    clear: right;
}

.rightCol {
    width: 40%;
    height: auto;
    float: right;
    margin-top: 60px;
}

.imgBox {
    width: 100%;
    height: 100px;
    /* margin-top: 250px; */
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-bottom: 20px;
}

.titleback {
    width: 100%;
    height: auto;
    color: #00a89d;
    font-family: 'cocomatpro-regular';
    font-size: .7em;
    line-height: 1em;
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
}

.dimensions {
    width: 100%;
    color: black;
    font-family: 'cocomatpro-regular';
    font-size: .8em;
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 20px;
}


.usertag {
    width: 100%;
    color: #00a89d;
    font-family: 'cocomatpro-bold';
    font-size: .8em;
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: -5px;
}


</style>
